/** @module MaterialSpec/MaterialPlanColor */
define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"dojo/dom-construct",
	"csi/def/Heading",
	"csi/heading/_base",
	"csi/heading/Ref",
	"csi/image/_base",
	"csi/reflection",
	"csi/xml"
], function(declare,lang,domConstruct,Heading,csiHeading,Ref,csiImage,reflection,xml) {

	var _colorImageHeading = lang.mixin(new Heading(), {m_id: reflection.ATTR_THUMBNAIL, m_right: "None"});

	return declare(Ref, {

		/**
		 * C8-9756 : Compare to Theme: Display of ColorSpec/ColoredMaterial image in "Color (Common)" field in compare mode.
		 */
		toHtmlStatic: function(ctx, h, refNode, actionData) {
			var b = this.inherited(arguments);

			if (ctx.view.displayColorImages) {
				var color = ctx.cache.getNode(this._getValue(ctx, h));
				if (color) {
					this._renderImage(ctx, refNode, color);
				}
			}

			return b;
		},

		/**
		 * Find color containing image and render into cell
		 * @param {Context} ctx
		 * @param {DOMNode} refNode
		 * @param {Node} color
		 */
		_renderImage: function(ctx, refNode, color) {
			var imageUrl = csiImage.getDefaultImage(color);

			if (!xml.isValidURL(imageUrl) && xml.isValidURL(color.ColorSpecification)) {
				imageUrl = csiImage.getDefaultImage(ctx.cache.getNode(color.ColorSpecification));
			}

			var	image = ctx.cache.getNode(imageUrl);
			if (image) {
				// render image with proper context
				var imageRenderer = csiHeading.getRenderer(xml.ATTR_URL, "Image");
				var	key = ctx.keyValue;
				ctx.keyValue = null;
				ctx.pushParams().setNode(image);
				imageRenderer._toHtml(ctx, _colorImageHeading, domConstruct.create("span", {"class":"csi-table-header-colorImage"}, refNode));
				ctx.keyValue = key;
				ctx.pop();
			}
		}

	});
});